import { ShieldAlert } from "lucide-react";

const STEPS = {
  windows: [
    "Si un écran bleu « Windows a protégé votre ordinateur » apparaît, cliquez sur « Informations complémentaires ».",
    "Cliquez ensuite sur le bouton « Exécuter quand même ».",
    "Acceptez la fenêtre de confirmation de Windows (« Oui »).",
  ],
  mac: [
    "Si macOS indique que le fichier ne peut pas être ouvert, cliquez sur « OK » (ou « Terminé »).",
    "Ouvrez le menu Pomme > Réglages Système > Confidentialité et sécurité, puis descendez en bas de la page.",
    "Cliquez sur « Ouvrir quand même », saisissez votre mot de passe, puis relancez le fichier.",
  ],
};

export const UnsignedHelp = ({ os }) => (
  <details className="group rounded-md bg-amber-50 border border-amber-200 text-amber-900 text-sm" data-testid={`unsigned-help-${os}`}>
    <summary className="cursor-pointer list-none flex items-center gap-2 px-3 py-2 font-medium" data-testid={`unsigned-help-${os}-toggle`}>
      <ShieldAlert className="h-4 w-4 shrink-0" />
      {os === "windows" ? "Windows affiche un avertissement ?" : "Mac bloque l'ouverture ?"}
      <span className="ml-auto text-xs underline group-open:hidden">Voir comment faire</span>
    </summary>
    <ol className="list-decimal pl-8 pr-3 pb-3 space-y-1">
      {STEPS[os].map((s) => <li key={s}>{s}</li>)}
    </ol>
  </details>
);
